import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useReactiveVar } from "@apollo/client";
import { errorsVar } from "../../cache/cache";
import { useDeleteRoleMutation } from "../../types/graphql";
import { setError } from "../../misc/common";
import { ROLES } from "../../graphql/queries";
import { useTranslation } from "react-i18next";

import "./styles.css";

const Button = React.lazy(() => import("../../components/common/Button"));

const DeleteRole: React.FC = () => {
    const { t } = useTranslation("admin");
    let errors = useReactiveVar(errorsVar);
    const navigate = useNavigate();
    const location = useLocation();
    interface LocationState {
        roleId: string;
    }
    const locationState = location.state as LocationState;

    const [deleteRole] = useDeleteRoleMutation({
        refetchQueries: () => {
            return [
                {
                    query: ROLES,
                },
            ];
        },
        onCompleted() {
            navigate(location.pathname + location.search);
        },
        onError(error) {
            errors = errorsVar([]);

            if (error?.message === "Some users have this role, it can't be deleted ") {
                errorsVar(
                    setError(errors, [
                        {
                            place: "delete-role.user-exist",
                            message: t("errors.roleUserExistError"),
                        },
                    ]),
                );
            }
        },
    });

    const existUserError = errors.find((el) => el?.place === "delete-role.user-exist");

    return (
        <div className="delete-role">
            <div className="delete-role__container">
                <p className="delete-role_title">{t("deleteRoleConfirm")}</p>
                {existUserError && <div className="delete-role-error">{existUserError.message}</div>}
            </div>
            <div>
                <Button
                    text={t("delete")}
                    onClick={() => deleteRole({ variables: { id: locationState?.roleId } })}
                    disabled={false}
                    mode="red"
                    className="login_btn"
                />
            </div>
        </div>
    );
};

export default DeleteRole;
